import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import "./Services.scss";

import Testimonial from '../Components/Testimonial';
import CallAction from '../Components/CallAction';

import BgVd1 from "./../Images/bg1.gif";
import BgVd2 from "./../Images/bg2.gif";


import bannImg1w from "./../Images/gallery-3-1.webp";
import bannImg1 from "./../Images/gallery-3-1.jpg";
import bannImg2w from "./../Images/gallery-3-2.webp";
import bannImg2 from "./../Images/gallery-3-2.jpg";
import bannImg3w from "./../Images/gallery-3-3.webp";
import bannImg3 from "./../Images/gallery-3-3.jpg";
import bannImg4w from "./../Images/gallery-3-4.webp";
import bannImg4 from "./../Images/gallery-3-4.jpg";
import bannImg5w from "./../Images/gallery-3-5.webp";
import bannImg5 from "./../Images/gallery-3-5.jpg";
import bannImg6w from "./../Images/gallery-3-6.webp";
import bannImg6 from "./../Images/gallery-3-6.jpg";
import bannImg7w from "./../Images/gallery-3-7.webp";
import bannImg7 from "./../Images/gallery-3-7.jpg";

import ServImg1w from "./../Images/serv-icon1.webp";
import ServImg1 from "./../Images/serv-icon1.png";
import ServImg2w from "./../Images/serv-icon6.webp";
import ServImg2 from "./../Images/serv-icon6.png";
import ServImg3w from "./../Images/serv-icon4.webp";
import ServImg3 from "./../Images/serv-icon4.png";
import ServImg4w from "./../Images/serv-icon5.webp";
import ServImg4 from "./../Images/serv-icon5.png";
import ServImg5w from "./../Images/serv-icon2.webp";
import ServImg5 from "./../Images/serv-icon2.png";
import ServImg6w from "./../Images/serv-icon3.webp";
import ServImg6 from "./../Images/serv-icon3.png";

import Servbg1w from "./../Images/service-img1.webp";
import Servbg1 from "./../Images/service-img1.jpg";
import Servbg2w from "./../Images/service-img2.webp";
import Servbg2 from "./../Images/service-img2.jpg";
import Servbg3w from "./../Images/service-img3.webp";
import Servbg3 from "./../Images/service-img3.jpg";

const BannList4 = [
  { srset1: bannImg1w, srset2: bannImg1 },
  { srset1: bannImg2w, srset2: bannImg2 },
  { srset1: bannImg3w, srset2: bannImg3 },
  { srset1: bannImg4w, srset2: bannImg4 },
  { srset1: bannImg5w, srset2: bannImg5 },
  { srset1: bannImg6w, srset2: bannImg6 },
  { srset1: bannImg7w, srset2: bannImg7 },
]

const servList1 = [
  { title: "Branding", srset1: ServImg1w, srset2: ServImg1, para1: "We build bold, scroll-stopping brands with vibe, voice, and vision.", para2: "Your identity, but make it unforgettable.", delay: "400" },
  { title: "Broadcasting", srset1: ServImg2w, srset2: ServImg2, para1: "We turn your message into impact, from content to campaigns, for brands of all sizes.", para2: "Whether you're just starting or scaling up, you're always heard, always seen.", delay: "600" },
]

const servList2 = [
  { title: "Photography", srset1: ServImg3w, srset2: ServImg3, para1: "We capture more than moments, we frame emotion, style, and story.", para2: "From corporate videos to digital social buzz, every shot turns your brand into a scroll-stopper.", delay: "400" },
  { title: "Videography", srset1: ServImg4w, srset2: ServImg4, para1: "From reels to real impact.", para2: "We shoot, edit, and deliver visuals that move your audience literally.", delay: "600" },
]

const servList3 = [
  { title: "SEO", srset1: ServImg5w, srset2: ServImg5, para1: "We boost your brand where it matters most, search.", para2: "Smart keywords. Real results. Top of the page, every time.", delay: "400" },
  { title: "Web Development", srset1: ServImg6w, srset2: ServImg6, para1: "Clean code. Killer design. Seamless experience.", para2: "We build websites that load fast and look fire.", delay: "600" },
]

export default function Services() {
  const handleContactClick = () => {
    window.dispatchEvent(new Event("scrollToForm"));
  };
  useEffect(() => {
    const handleResize = () => {
      setTimeout(() => {
        var i = 0;
        var set = 0;
        var cols = document.querySelectorAll("[data-col]");
        var encountered = [];
        for (i = 0; i < cols.length; i++) {
          var attr = cols[i].getAttribute("data-col");
          if (encountered.indexOf(attr) === -1) {
            encountered.push(attr);
          }
        }
        for (set = 0; set < encountered.length; set++) {
          var col = document.querySelectorAll(
            '[data-col="' + encountered[set] + '"]'
          );
          var group = [];
          for (i = 0; i < col.length; i++) {
            col[i].style.height = "auto";
            var elementHeight = col[i].offsetHeight;
            group.push(elementHeight);
          }
          for (i = 0; i < col.length; i++) {
            col[i].style.height = "auto";
            col[i].style.height = Math.max.apply(Math, group) + "px";
          }
        }
      }, 500);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
  }, []);
  return (
    <>
      <div className='banner2 banner-services'>
        <div className='video-bg1'><img src={BgVd1} alt='' /></div>
        <div className='service-slider' data-aos="fade-up" data-aos-once='true'>
          <div className='service-slider-track'>
            {BannList4.map((item, index) => {
              return (
                <div key={index} className='service-slide'>
                  <picture>
                    <source srcSet={item.srset1} type="image/webp" />
                    <source srcSet={item.srset2} type="image/jpeg" />
                    <img
                      src={item.srset2}
                      alt="ZYX Media"
                      title="ZYX Media"
                      width="978"
                      height="1224"
                    />
                  </picture>
                </div>
              )
            })}
            {BannList4.map((item, index) => {
              return (
                <div key={index} className='service-slide'>
                  <picture>
                    <source srcSet={item.srset1} type="image/webp" />
                    <source srcSet={item.srset2} type="image/jpeg" />
                    <img
                      src={item.srset2}
                      alt="ZYX Media"
                      title="ZYX Media"
                      width="978"
                      height="1224"
                    />
                  </picture>
                </div>
              )
            })}
            <div className='clear'></div>
          </div>
        </div>
        <div className='container-fluid sectin pb-0'>
          <div className='row'>
            <div className='col-xl-9 col-18 banner3-lt-ct mb-1'>
              <h1 className='fw-300 txt-xl-lt txt-center mb-3' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">Power Up Your Ideas. Build What Matters.</h1>
              <div className='txt-xl-lt txt-center' data-aos="fade-up" data-aos-once='true' data-aos-delay="500"><span className='avatar-list-stacked me-2'><span className='avatar avatar1'></span><span className='avatar avatar2'></span><span className='avatar avatar3'></span></span><span className='f-18 mb-0 pe-4'><span className='f-18 mb-0 fw-600'>100+</span> Success Stories & loading...</span></div>
            </div>
            <div className='col-xl-8 col-18 float-xl-end banner3-rt-ct mb-0'>
              <p className='f-18 txt-xl-lt txt-center line-ht-24 mb-2' data-aos="fade-up" data-aos-once='true' data-aos-delay="600">With ZYX, your vision gets the clarity, creativity, and momentum it deserves.</p>
              <p className='f-18 txt-xl-lt txt-center line-ht-24 mb-2' data-aos="fade-up" data-aos-once='true' data-aos-delay="600">We collaborate, innovate, and activate strategies that turn inspiration into real-world impact.</p>
              <p className='f-18 txt-xl-lt txt-center line-ht-24 mb-3' data-aos="fade-up" data-aos-once='true' data-aos-delay="600">Let's create bold brands, lasting value, and a future that thrives together.</p>
              <div className='txt-xl-lt txt-center' data-aos="fade-up" data-aos-once='true' data-aos-delay="800"><Link className="glow-btn m-auto ms-xl-0" onClick={handleContactClick}><span>Connect with us</span></Link></div>
            </div>
          </div>
        </div>
        <div className='video-bg2'><img src={BgVd2} alt='' /></div>
      </div>
      <div className='services-dts-cont bg-pattern'>
        <div className='container-fluid sectin'>
          <div className='row'>
            <div className='col-lg-9 col-18 mb-lg-0 sdc-lt-cont' data-col="eq-ht">
              <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                <tbody>
                  <tr>
                    <td>
                      <div data-aos="fade-down" data-aos-once='true'><h2 className='h1 fw-300 txt-lt mb-6'>Signal & Style Services</h2></div>
                      <ul className='float-none'>
                        {servList1.map((item, index) => {
                          return (
                            <li key={index} data-aos="fade-up" data-aos-once='true' data-aos-delay={item.delay}>
                              <div className='serv-icon mb-4'>
                                <picture>
                                  <source srcSet={item.srset1} type="image/webp" />
                                  <source srcSet={item.srset2} type="image/png" />
                                  <img src={item.srset2} alt={item.title} title={item.title} width="54" height="54" />
                                </picture>
                              </div>
                              <div className='serv-dts'>
                                <h6 className='h9 fw-400 mb-4'>{item.title}</h6>
                                <p className='f-16 mb-1 line-ht-24'>{item.para1}</p>
                                <p className='f-16 mb-0 line-ht-24'>{item.para2}</p>
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='col-lg-9 col-18 mb-0 float-lg-end sdc-rt-cont' data-col="eq-ht" data-aos="fade-left" data-aos-once='true' data-aos-delay="800">
              <div data-col="eq-ht"><picture>
                <source srcSet={Servbg1w} type="image/webp" />
                <source srcSet={Servbg1} type="image/jpg" />
                <img src={Servbg1} alt="Signal & Style Services" title="Signal & Style Services" width="1244" height="700" />
              </picture></div>
            </div>
          </div>
          <div className='clear'></div>
        </div>
        <div className='container-fluid sectin'>
          <div className='row'>
            <div className='col-lg-9 col-18 mb-lg-0 float-lg-end sdc-lt-cont' data-col="eq-ht">
              <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                <tbody>
                  <tr>
                    <td>
                      <div data-aos="fade-down" data-aos-once='true'><h2 className='h1 fw-300 txt-lt mb-6'>Lights. Lens. Legacy.</h2></div>
                      <ul className='float-none'>
                        {servList2.map((item, index) => {
                          return (
                            <li key={index} data-aos="fade-up" data-aos-once='true' data-aos-delay={item.delay}>
                              <div className='serv-icon mb-4'>
                                <picture>
                                  <source srcSet={item.srset1} type="image/webp" />
                                  <source srcSet={item.srset2} type="image/png" />
                                  <img src={item.srset2} alt={item.title} title={item.title} width="54" height="54" />
                                </picture>
                              </div>
                              <div className='serv-dts'>
                                <h6 className='h9 fw-400 mb-4'>{item.title}</h6>
                                <p className='f-16 mb-1 line-ht-24'>{item.para1}</p>
                                <p className='f-16 mb-0 line-ht-24'>{item.para2}</p>
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='col-lg-9 col-18 mb-0 sdc-rt-cont' data-col="eq-ht" data-aos="fade-right" data-aos-once='true' data-aos-delay="800">
              <div data-col="eq-ht" className='float-lg-end'><picture>
                <source srcSet={Servbg2w} type="image/webp" />
                <source srcSet={Servbg2} type="image/jpg" />
                <img src={Servbg2} alt="Lights. Lens. Legacy." title="Lights. Lens. Legacy." width="1244" height="700" style={{ objectPosition: 'right' }} />
              </picture></div>
            </div>
          </div>
          <div className='clear'></div>
        </div>
        <div className='container-fluid sectin'>
          <div className='row'>
            <div className='col-lg-9 col-18 mb-lg-0 sdc-lt-cont' data-col="eq-ht">
              <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                <tbody>
                  <tr>
                    <td>
                      <div data-aos="fade-down" data-aos-once='true'><h2 className='h1 fw-300 txt-lt mb-6'>Code. Rank. Repeat.</h2></div>
                      <ul className='float-none'>
                        {servList3.map((item, index) => {
                          return (
                            <li key={index} data-aos="fade-up" data-aos-once='true' data-aos-delay={item.delay}>
                              <div className='serv-icon mb-4'>
                                <picture>
                                  <source srcSet={item.srset1} type="image/webp" />
                                  <source srcSet={item.srset2} type="image/png" />
                                  <img src={item.srset2} alt={item.title} title={item.title} width="54" height="54" />
                                </picture>
                              </div>
                              <div className='serv-dts'>
                                <h6 className='h9 fw-400 mb-4'>{item.title}</h6>
                                <p className='f-16 mb-1 line-ht-24'>{item.para1}</p>
                                <p className='f-16 mb-0 line-ht-24'>{item.para2}</p>
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='col-lg-9 col-18 mb-0 float-lg-end sdc-rt-cont' data-col="eq-ht" data-aos="fade-left" data-aos-once='true' data-aos-delay="800">
              <div data-col="eq-ht"><picture>
                <source srcSet={Servbg3w} type="image/webp" />
                <source srcSet={Servbg3} type="image/jpg" />
                <img src={Servbg3} alt="Code. Rank. Repeat." title="Code. Rank. Repeat." width="1244" height="700" />
              </picture></div>
            </div>
          </div>
          <div className='clear'></div>
        </div>
      </div>
      <Testimonial />
      <CallAction />
    </>
  )
}
